import { render } from "./ChangeSharedFSDiskOffering.vue?vue&type=template&id=85f67006&scoped=true"
import script from "./ChangeSharedFSDiskOffering.vue?vue&type=script&lang=js"
export * from "./ChangeSharedFSDiskOffering.vue?vue&type=script&lang=js"

import "./ChangeSharedFSDiskOffering.vue?vue&type=style&index=0&id=85f67006&lang=scss&scoped=true"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f67006"]])

export default __exports__